import moment from "moment";
import { notify } from "DMS/Utils/modal";
import { changeMapWidth, recenterMap, formatTime } from "DMS/Controllers/geolocController";
//Create and hydrate info panel
export async function createInformationPanelContainer(splittedData, context) {
    let optionsPanel = document.getElementById('colForOptions');
    let promises = [
        await createDiv('', 'information_panel'),
        await createDiv('panel panel-primary', ''),
        await createDiv('panel-heading', ''),
        await createDiv('panel-body', '')
    ];
    if (context === 'tour') {
        return Promise.all(promises).then(panels => {
            hydrateTourPanelHead(panels[2], splittedData.forHeading);
            panels[1].appendChild(panels[2]);
            hydrateTourPanelbody(panels[3], splittedData.forBody);
            panels[1].appendChild(panels[3]);
            optionsPanel.appendChild(panels[0]);
            panels[0].appendChild(panels[1]);
        });
    }
    else {
        return Promise.all(promises).then(panels => {
            hydrateTechPanelHead(panels[2], splittedData.forHeading);
            panels[1].appendChild(panels[2]);
            hydrateTechPanelBody(panels[3], splittedData.forBody);
            panels[1].appendChild(panels[3]);
            optionsPanel.appendChild(panels[0]);
            panels[0].appendChild(panels[1]);
            window.panelContext = true;
            return Promise.resolve();
        }).then(changeMapWidth).then(recenterMap);
    }
}
function createDiv(divClass = '', divId = '') {
    return new Promise(function (resolve) {
        let panel = document.createElement('DIV');
        panel.setAttribute('class', divClass);
        panel.setAttribute('id', divId);
        resolve(panel);
    });
}
function hydrateTourPanelHead(panelHead, data) {
    let toInnerHTML = '<p id="panelTech">';
    toInnerHTML += data.tech + ' - ' + moment(data.tourDate).format('LL');
    toInnerHTML += '</p>';
    panelHead.innerHTML = toInnerHTML;
}
function hydrateTechPanelHead(panelHead, address) {
    let toInnerHTML = '<p>';
    toInnerHTML += address;
    toInnerHTML += '</p>';
    panelHead.innerHTML = toInnerHTML;
}
async function hydrateTourPanelbody(partOfPanel, data) {
    // init timeToNext et distanceToNext
    // = tps et distance entre adressedepart 1ere etape tournee
    let timeToNext = formatTime(data['adressedepart']['time']);
    let distanceToNext = Math.round(data['adressedepart']['distance'] / 1000) + ' Km';
    let toNotify = '';
    let toInnerBody = '<table class="table table-striped">';
    toInnerBody += '<tr>';
    toInnerBody += '<td style="max-width: 40px;"></td>';
    toInnerBody += '<td  style="max-width: 25px;"><div class="icon-container"><i class="fa fa-home special-icon"></i></div></td>';
    toInnerBody += '<td>' + data['adressedepart']['address'] + '</td>';
    toInnerBody += '</tr>';
    for (let bodyContent in data) {
        if (bodyContent.startsWith('file')) {
            let fileDataLength = data[bodyContent].length;
            for (let file = 0; file < fileDataLength; file++) {
                let nextFile = file + 1;
                let dates = await getFormattedStart(data[bodyContent][file]['prevule'], parseInt(data[bodyContent][file]['tempsestime']));
                toInnerBody += '<tr>';
                toInnerBody += '<td ">' + distanceToNext;
                toInnerBody += '<br>' + timeToNext + '</td>';
                toInnerBody += '<td><div class="file-icon-container"><p class="file_number">' + nextFile + '</p></div></td>';
                toInnerBody += '<td><p style="text-decoration:underline; font-weight: bold">' + fileNumber + data[bodyContent][file]['numdossier'] + '</p>';
                toInnerBody += '<p>' + data[bodyContent][file]['nomclientlivraison'] + '</br>' + data[bodyContent][file]['address'] + '</p>';
                toInnerBody += '<p>' + heureDeb + ': </br>' + dates['start'] + '</p>';
                toInnerBody += '<p>' + heureFin + ': </br>' + dates['end'] + '</p>';
                toInnerBody += '<p>' + typeEntree + ': </br>' + data[bodyContent][file]['typeentree'] + '</p></td>';
                toInnerBody += '</tr>';
                if (data[bodyContent][file]['address'] === '') {
                    toNotify += '<p>' + fileNumber + data[bodyContent][file]['numdossier'] + '</p>';
                }
                if (nextFile == fileDataLength
                    || (typeof data[bodyContent][nextFile] !== 'undefined'
                        && typeof data[bodyContent][nextFile]['time'] !== 'undefined'
                        && data[bodyContent][nextFile]['time'] !== false)) {
                    timeToNext = formatTime(data[bodyContent][file]['time']);
                    distanceToNext = Math.round(data[bodyContent][file]['distance'] / 1000) + ' Km';
                }
                else {
                    timeToNext = '';
                    distanceToNext = noData;
                }
            }
        }
    }
    toInnerBody += '<tr>';
    toInnerBody += '<td ">' + distanceToNext;
    toInnerBody += '<br>' + timeToNext + '</td>';
    toInnerBody += '<td><div class="icon-container"><i class="fa fa-home special-icon"></i></div></td>';
    toInnerBody += '<td>' + data['adressearrivee']['address'] + '</td>';
    toInnerBody += '</tr>';
    toInnerBody += '</table>';
    partOfPanel.innerHTML = toInnerBody;
    if (toNotify !== '') {
        toNotify = '<p>' + wrongAddress + '</p>' + toNotify;
        notify(toNotify, 'danger');
    }
}
async function hydrateTechPanelBody(panelBody, data) {
    let toInnerBody = '<table class="table table-striped">';
    toInnerBody += '<thead>';
    toInnerBody += '<td>N°</td>';
    toInnerBody += '<td>' + codetechtrad + '</td>';
    toInnerBody += '<td>' + nomtechtrad + '</td>';
    toInnerBody += '</thead>';
    for (let tech in data) {
        toInnerBody += '<tr>';
        toInnerBody += '<td>' + data[tech]['bbmindex'] + '</td>';
        toInnerBody += '<td>' + tech + '</td>';
        toInnerBody += '<td>' + data[tech]['nomtechnicien'] + '</td>';
        toInnerBody += '</tr>';
    }
    toInnerBody += '</table>';
    panelBody.innerHTML = toInnerBody;
}
export async function splitDataToDisplay(dataToDisplay, context) {
    return new Promise(function (resolve) {
        let splittedData = [];
        if (context === 'tour') {
            resolve(getTourData(dataToDisplay));
        }
        else if (context === 'location') {
            splittedData['forBody'] = [];
            for (let tech in dataToDisplay) {
                if (splittedData['forHeading'] === undefined)
                    splittedData['forHeading'] = dataToDisplay[tech]['address'];
                splittedData['forBody'][tech] = dataToDisplay[tech];
            }
            ;
            resolve(splittedData);
        }
    });
}
function getTourData(dataToDisplay) {
    return new Promise(function (resolve) {
        let forHeading = {};
        let forBody = {};
        forBody.files = [];
        let arrayOfFiles = [];
        for (let tour in dataToDisplay) {
            if (tour === 'tech') {
                forHeading.tech = dataToDisplay[tour];
            }
            else if (tour === 'tourDate') {
                forHeading.tourDate = dataToDisplay[tour];
            }
            else if (tour === 'adressedepart') {
                forBody.adressedepart = dataToDisplay[tour];
            }
            else if (tour === 'adressearrivee') {
                forBody.adressearrivee = dataToDisplay[tour];
            }
            else if (tour === 'tech_pos') {
                null;
            }
            else {
                arrayOfFiles.push(dataToDisplay[tour]);
            }
        }
        //To resort files.. Long live to javascript..!
        for (let i = 0; i < arrayOfFiles.length; i++) {
            forBody.files.push(dataToDisplay['file_' + i]);
        }
        let splittedData = {
            'forHeading': forHeading,
            'forBody': forBody
        };
        resolve(splittedData);
    });
}
function getFormattedStart(start, estimatedTime) {
    return new Promise(function (resolve) {
        let baseDate = moment.utc(start);
        let startDate = moment(baseDate).format('LLLL');
        let endDate = baseDate.add(estimatedTime, 'seconds').format('LLLL');
        let dateObject = {
            'start': startDate,
            'end': endDate
        };
        resolve(dateObject);
    });
}
//# sourceMappingURL=GoogleMapInfoPanel.js.map